import '.da{flex-shrink:0;}.ssr-plugin'
import '.gm{min-width:260px;}.ssr-plugin'
import '.w{max-width:480px;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.a1{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.b6{user-select:none;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.r{gap:24px;}.ssr-plugin'
import '.z{flex:1;}.ssr-plugin'
import '.d7{overflow:auto;}.ssr-plugin'
import '.do{gap:2px;}.ssr-plugin'
import '.gn{padding:8px 8px 4px;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.go{padding-top:4px;}.ssr-plugin'
import '.gp{padding-bottom:4px;}.ssr-plugin'
import '.eq{padding-left:8px;}.ssr-plugin'
import '.er{padding-right:8px;}.ssr-plugin'
import '.fv{min-height:32px;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.q{cursor:pointer;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.af{gap:4px;}.ssr-plugin'
import '.gq{min-height:24px;}.ssr-plugin'
import { ReactNode, createContext, useContext } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { Counter } from '../Counter/index.js'

type SidebarContextType = {
  value?: string
  onChange: (value: string) => void
}
const SidebarContext = createContext<SidebarContextType>({ onChange: () => {} })

type SidebarProps = {
  value?: string
  onChange: (value: string) => void
  children: ReactNode
  side?: 'left' | 'right' | false
}

function Sidebar({ children, value, onChange, side = 'left' }: SidebarProps) {
  return (
    <SidebarContext.Provider value={{ value, onChange }}>
      <div className="da gm w a0 a1 a i b6"
      >
        <div className="h a1 a i r"
        >
          {children}
        </div>
      </div>
    </SidebarContext.Provider>
  )
}

type SidebarHeaderProps = {
  children: ReactNode
}

function SidebarHeader({ children }: SidebarHeaderProps) {
  return <div className="a">{children}</div>
}

type SidebarFooterProps = {
  children: ReactNode
}

function SidebarFooter({ children }: SidebarFooterProps) {
  return <div className="a">{children}</div>
}

type SidebarItemsProps = {
  children: ReactNode
}

function SidebarItems({ children }: SidebarItemsProps) {
  return (
    <div className="z r a h i d7"
    >
      {children}
    </div>
  )
}

type SidebarGroupProps = {
  children: ReactNode
  title: string
}

function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="a i do">
      <div className="gn">
        <Text selectableText={false} variant="subtext-medium" color="neutral60">
          {title}
        </Text>
      </div>
      {children}
    </div>
  )
}

type SidebarItemProps = {
  children: ReactNode
  value: string
  icon?: IconProps['variant']
  description?: string
  counter?: number
}

function SidebarItem({
  children,
  value,
  icon,
  description,
  counter,
}: SidebarItemProps) {
  const { value: contextValue, onChange } = useContext(SidebarContext)
  const active = value === contextValue

  return (
    <styled.div className="a b go gp eq er fv bl q"
      data-active={active ? active : undefined}
      style={{
        borderRadius: radius[12],
        '&:hover:not([data-active])': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]:hover': {
          background: colors.neutral10Adjusted,
        },
      }}
      onClick={() => {
        onChange(value)
      }}
    >
      {icon && <Icon variant={icon} />}
      <div className="a i c af gq"
      >
        <Text selectableText={false} color="neutral80" variant="display-medium">
          {children}
        </Text>
        {description && (
          <Text
            selectableText={false}
            color="neutral60"
            variant="subtext-regular"
          >
            {description}
          </Text>
        )}
      </div>
      {counter > 0 && (
        <Counter style={{ marginLeft: 'auto' }}>{counter}</Counter>
      )}
    </styled.div>
  )
}

Sidebar.Items = SidebarItems
Sidebar.Group = SidebarGroup
Sidebar.Item = SidebarItem
Sidebar.Header = SidebarHeader
Sidebar.Footer = SidebarFooter

export { Sidebar }
export type { SidebarProps }
